import { render, staticRenderFns } from "./ClientBids.vue?vue&type=template&id=c08c0d4a&scoped=true&"
import script from "./ClientBids.vue?vue&type=script&lang=js&"
export * from "./ClientBids.vue?vue&type=script&lang=js&"
import style0 from "./ClientBids.vue?vue&type=style&index=0&id=c08c0d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08c0d4a",
  null
  
)

export default component.exports